import React from 'react';
interface CTAButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  className?: string;
  href?: string;
  variant?: 'primary' | 'secondary';
  fullWidth?: boolean;
}
export function CTAButton({
  children,
  className,
  href,
  variant = 'primary',
  fullWidth = false,
  ...props
}: CTAButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-black uppercase tracking-wide transition-all duration-300 transform hover:scale-105 active:scale-95 rounded-lg py-4 px-8 text-base md:text-lg leading-none shadow-xl';
  const variants = {
    primary: 'bg-[#FF6B00] hover:bg-[#e66000] text-white border-b-4 border-[#cc5500] glow-orange',
    secondary: 'bg-[#0B1F3A] hover:bg-[#081629] text-white border-b-4 border-[#050d1a] glow-blue'
  };
  const widthClass = fullWidth ? 'w-full' : '';
  if (href) {
    return <a href={href} className={`${baseStyles} ${variants[variant]} ${widthClass} ${className || ''}`} {...props as React.AnchorHTMLAttributes<HTMLAnchorElement>} data-id="element-31">
        {children}
      </a>;
  }
  return <button className={`${baseStyles} ${variants[variant]} ${widthClass} ${className || ''}`} {...props} data-id="element-32">
      {children}
    </button>;
}